import { Component, Suspense } from 'react';

// project imports
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const CHUNK_RELOAD_KEY = 'lims-chunk-reload-attempted';

const isChunkLoadError = (error) => {
    const message = error?.message || '';
    const name = error?.name || '';

    return name === 'ChunkLoadError' || /Loading chunk .* failed/i.test(message) || /Loading CSS chunk .* failed/i.test(message);
};

class ChunkErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        if (!isChunkLoadError(error)) {
            return;
        }

        const reloadKey = `${CHUNK_RELOAD_KEY}:${window.location.pathname}`;
        const hasReloaded = window.sessionStorage.getItem(reloadKey);

        if (!hasReloaded) {
            window.sessionStorage.setItem(reloadKey, 'true');
            window.location.reload();
        }
    }

    render() {
        const { children } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            return <div style={{ padding: 24 }}>Something went wrong while loading this page. Please refresh the page.</div>;
        }

        return children;
    }
}

const Loadable = (Component) => (props) =>
    (
        <ChunkErrorBoundary>
            <Suspense fallback={<Loader />}>
                <Component {...props} />
            </Suspense>
        </ChunkErrorBoundary>
    );

export default Loadable;
